import { TabbedPage } from "../../components/TabbedPage";
import { InventoryListPage } from "../inventory/InventoryListPage";
import { BulkInventoryPage } from "../inventory/BulkInventoryPage";
import { LowStockPage } from "../reports/LowStockPage";
import { ExpiringSoonPage } from "../reports/ExpiringSoonPage";
import { LabelsPage } from "./LabelsPage";

/** Merged "Stock" page (business-owner walkthrough follow-up: "view current stock, top
 * up stock, add new products" as one basic-nav destination) — All Stock (with the
 * create-product form and the "Top up stock" quick action, see `TopUpStockModal`), Low
 * Stock, Expiring Soon, Labels (bulk label printing, `LabelsPage.tsx`), and Import/Export,
 * each an existing page rendered unchanged as a tab. Old single-purpose routes
 * (`/inventory`, `/reports/low-stock`, `/reports/expiring-soon`, `/inventory/bulk`) redirect
 * here — see `App.tsx`. */
export function StockPage() {
  return (
    <TabbedPage
      title="Stock"
      defaultTab="all"
      tabs={[
        { key: "all", label: "All Stock", content: <InventoryListPage /> },
        { key: "low-stock", label: "Low Stock", content: <LowStockPage /> },
        { key: "expiring", label: "Expiring Soon", content: <ExpiringSoonPage /> },
        { key: "labels", label: "Labels", content: <LabelsPage /> },
        { key: "import-export", label: "Import / Export", content: <BulkInventoryPage /> },
      ]}
    />
  );
}
